// Detecta automaticamente a URL do backend
async function getApiUrl() {
  const configuredUrl =
    process.env.REACT_APP_API_URL ||
    (typeof import.meta !== "undefined" ? import.meta?.env?.VITE_API_URL : "") ||
    process.env.NEXT_PUBLIC_API_URL;

  if (configuredUrl) {
    return configuredUrl;
  }

  // Se está na mesma máquina, tenta descobrir via API
  try {
    // Primeiro tenta localhost
    const response = await fetch("http://localhost:3001/api/config/connection-info", {
      method: "GET",
      timeout: 2000,
    });

    if (response.ok) {
      const data = await response.json();
      return data.apiBaseUrl;
    }
  } catch (e) {
  }

  // Se não conseguiu, usa localhost como fallback
  return "http://localhost:3001/api";
}

// Para uso síncrono na inicialização, usa um padrão que permite await depois
let API_URL = "http://localhost:3001/api";

// Tenta descobrir de forma assíncrona se possível
if (typeof window !== "undefined") {
  getApiUrl().then((url) => {
    API_URL = url;
    // Notifica se a URL foi descoberta dinamicamente
    if (url !== "http://localhost:3001/api") {
    }
  });
}

export { API_URL };
